

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { MutationStatus } from 'react-query';
import {
  ApiButton,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from 'web-library';

const useStyles = makeStyles()((theme) =>
({
  buttonContainer: {
    marginTop: theme.spacing(3),
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  boldContent: {
    fontWeight: 'bold',
  },
}));

interface DialogButtonsProps {
  onDialogClose: () => void;
  apiButtonClick: () => void;
  apiButtonStatus: MutationStatus;
}

const DialogButtons = ({ onDialogClose, apiButtonStatus, apiButtonClick }: DialogButtonsProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <DialogActions id="candidate-dialog-action">
      <Box className={classes.buttonContainer}>
        <Button onClick={onDialogClose} variant="text">
          {t('specialConsideration->>Dialog.Cancel')}
        </Button>
        <ApiButton status={apiButtonStatus} type="submit" onClick={apiButtonClick}>
          {t('exam->>Instructions.Proceed')}
        </ApiButton>
      </Box>
    </DialogActions>
  );
};

interface ConfirmRemoveDialogProps {
  modalState: boolean;
  onDialogClose: () => void;
  proceedClick: () => void;
  title: string;
  contentText: string;
}

const ConfirmRemoveDialog = ({
  modalState,
  onDialogClose,
  proceedClick,
  title,
  contentText,
}: ConfirmRemoveDialogProps) => (
  <Dialog open={modalState} maxWidth="sm" onClose={onDialogClose}>
    <DialogTitle>
      <Typography variant="h4">{title}</Typography>
    </DialogTitle>
    <DialogContent>
      <DialogContentText variant="body1">{contentText}</DialogContentText>
    </DialogContent>
    <DialogButtons
      apiButtonStatus="idle"
      onDialogClose={onDialogClose}
      apiButtonClick={proceedClick}
    />
  </Dialog>
);

export default ConfirmRemoveDialog;
